import CheckCircle from '@mui/icons-material/CheckCircle'
import { Box, Container, Typography } from '@mui/material'
import MonetaryFormat from './MonetaryFormat'
import { isUndefined } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { useCFDContext } from 'pages/CustomerFacingDisplayPage/context/useCFDContext'

const FinishPaymentPage = () => {
    const { finishPaymentPayload: paymentDetail } = useCFDContext()
    const { t } = useTranslation()

    return (
        <Container sx={(x) => ({ background: x.palette.background.paper })}>
            <Box
                alignContent={'center'}
                justifyContent={'center'}
                display={'flex'}
                flexDirection={'column'}
                sx={(x) => {
                    return { height: '97svh' }
                }}
            >
                <Typography pt={2} align={'center'}>
                    <CheckCircle style={{ fontSize: 70 }} color="primary" />
                </Typography>
                <Typography pt={2} align={'center'} variant="h4">
                    {t('quick_sell.receipt_dialog.label.payment_complete')}
                </Typography>

                {!isUndefined(paymentDetail?.changeAmount) && (
                    <Typography
                        pt={2}
                        align={'center'}
                        variant="h4"
                        style={{ fontWeight: 600 }}
                    >
                        {t('quick_sell.receipt_dialog.label.change')}:{' '}
                        <MonetaryFormat
                            variant="inherit"
                            component="span"
                            value={paymentDetail?.changeAmount}
                        />
                    </Typography>
                )}
                {paymentDetail?.message && (
                    <Typography py={7} variant="h5" align={'center'}>
                        {paymentDetail?.message}
                    </Typography>
                )}

                {paymentDetail?.email && (
                    <Box justifyItems={'center'} p={2}>
                        <Typography variant="h6">
                            Email Address for receipt:
                        </Typography>

                        <Typography fontWeight={700} p={1} variant="h5">
                            {paymentDetail?.email}
                        </Typography>
                    </Box>
                )}
            </Box>
        </Container>
    )
}

export default FinishPaymentPage
